import React from 'react'
import Imgix from 'react-imgix'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/scrollbar/scrollbar.scss'
import 'swiper/components/pagination/pagination.scss'
import '../../styles/customSwiper.scss'
import { useResolutionService } from '../../hooks'

const SwiperSlideQuests = () => {
  const { isMDScreen } = useResolutionService()
  return (
    <div>
      <Swiper
        slidesPerView={3}
        navigation
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          425: {
            slidesPerView: 1.1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.1,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 1.5,
            spaceBetween: 30,
          },
          1440: {
            slidesPerView: 2.5,
            spaceBetween: 40,
          },
          2560: {
            slidesPerView: 2.5,
            spaceBetween: 80,
          },
        }}
        className='overflow-xy custom-swiper custom-swiper-arrow'>
        <SwiperSlide>
          {' '}
          <div style={{ width: '100%' }}>
            <Imgix
              className='border-radius-10 mt-4 lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:3',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticQuest1.jpg`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${process.env.REACT_APP_IMG_SOURCE}/StaticQuest1.jpg?ar=${
                  isMDScreen ? '2:1' : '5:3'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h4 className='s10a pt-16px font-saffron-700'>Preparation</h4>
            <h2 className='s2 fst-italic'>Clarify Your Intentions</h2>
            <p className='s6 pt-16px'>
              Before your experience begins, you’ll take our True Prosperity
              Assessment which is designed to measure 15 key areas of personal
              and professional fulfillment. You’ll then meet with one of our
              coaches to review your results and clarify your intentions,
              ensuring you enter the experience with clarity, focus, and
              purpose.
            </p>{' '}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          {' '}
          <div style={{ width: '100%' }}>
            <Imgix
              className='border-radius-10 mt-4 lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:3',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticQuest2.png`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${process.env.REACT_APP_IMG_SOURCE}/StaticQuest2.png?ar=${
                  isMDScreen ? '2:1' : '5:3'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h4 className='s10a mt-3 font-saffron-700'>Experience</h4>
            <h2 className='s2 fst-italic'>Curated, Immersive Experience</h2>
            <p className='s6'>
              Next, you’ll step into an experience thoughtfully curated by
              Abroad’s experience designers, faculty, and coaches. Whether it’s
              a Quest, Pilgrimage, or local gathering, each experience is
              designed to help you slow down, reconnect to what matters most,
              and access the wisdom within.
            </p>{' '}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          {' '}
          <div style={{ width: '100%' }}>
            <Imgix
              className='border-radius-10 mt-4 lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:3',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticQuest3.jpg`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${process.env.REACT_APP_IMG_SOURCE}/StaticQuest3.jpg?ar=${
                  isMDScreen ? '2:1' : '5:3'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h4 className='s10a mt-3 font-saffron-700'>Integration</h4>
            <h2 className='s2 fst-italic'>Wisdom in Action</h2>
            <p className='s6'>
              After your experience, you’ll reconnect with your coach to reflect
              on key insights and define meaningful next steps. We encourage you
              to stay connected with your cohort and the broader community—and
              to consider ongoing coaching to help you put wisdom into action in
              your life, leadership, and work.
            </p>{' '}
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  )
}

export default SwiperSlideQuests
